import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/genui-working-light.webp")